import apiClient from '../client';

/**
 * GET /markets
 * Returns all enabled markets for the market switcher.
 */
export const getEnabledMarkets = async () => {
  const { data } = await apiClient.get('/markets');
  return data;
};

/**
 * GET /markets/detect
 * Returns the IP-detected market and whether a redirect should be suggested.
 * Send X-Market-Code header with the currently active market code so the backend
 * can compute shouldSuggestRedirect.
 *
 * @param {string|null} currentMarketCode  The client's current active market code
 */
export const detectMarket = async (currentMarketCode = null) => {
  const headers = currentMarketCode ? { 'X-Market-Code': currentMarketCode } : {};
  const { data } = await apiClient.get('/markets/detect', { headers });
  return data; // { detectedMarket, shouldSuggestRedirect, requestedMarketCode }
};

/**
 * GET /api/v1/admin/markets  (admin only)
 */
export const adminGetMarkets = async (adminApiClient) => {
  const { data } = await adminApiClient.get('/admin/markets');
  return data;
};
